<template>
  <div class="main-view">
    <a href="/" class="black-logo"><img style="width: 250px; height: 80px" src="/img/logo.png" /></a>
    <div class="login-form">
      <div class="form-head">
        <h2>
          <template v-if="action === ACTION.signUp">
            {{$t("account.signUp")}}
          </template>
          <template v-if="action === ACTION.signIn">
            {{$t("account.signIn")}}
          </template>
          <template v-if="action === ACTION.password">
            {{$t("account.forgotPassword")}}
          </template>
        </h2>
        <p v-show="action === ACTION.signIn" class="register-p"><a href="/login?action=signUp">{{$t("account.now")}} {{$t("account.signUp")}}</a></p>
        <p v-show="action === ACTION.signUp" class="login-p"><a href="/login?action=signIn">{{$t("account.now")}} {{$t("account.signIn")}}</a></p>
      </div>
      <div class="form-body">
        <p class="err-msg"></p>
        <div class="ui-input"><input v-model.trim="form.account" :placeholder="$t('account.email')" type="email" /></div>
        <div v-show="action === ACTION.signUp" class="ui-input"><input v-model.trim="form.name" :placeholder="'name'" type="text" /></div>
        <div v-show="action === ACTION.signUp" class="ui-input"><input v-model.trim="form.phone" :placeholder="'phone number'" type="text" /></div>
        <div v-show="action === ACTION.signUp" class="ui-input" style="position: relative;">
          <select style="padding: 0;border: navajowhite;box-shadow: none;height: 30px;line-height: 30px;" v-model="form.userType" class="form-control input-lg">
            <option value="1">personal buyer</option>
            <option value="2">wholesaler</option>
          </select>
          <span v-if="!form.userType" style="position: absolute;color: #757575;top: 50%;left: 0;transform: translateY(-50%);">are you a personal buyer or wholesaler?</span>
        </div>
        <div v-show="action === ACTION.signUp" class="ui-input"><input v-model.trim="form.address" :placeholder="'where are you from?'" type="text" /></div>
        <div class="ui-input"><input v-model.trim="form.password" :placeholder="$t('account.password')" type="password" /></div>
        <div v-show="action === ACTION.signUp||action === ACTION.password" class="ui-input confirmPassword"><input v-model="form.secondPassword" :placeholder="$t('account.confirmPassword')" type="password" /></div>
        <div class="ui-input narrow-input">
          <input v-model.trim="form.code" name="code" :placeholder="$t('account.captcha')" type="text" />
          <span class="sms-button" style="cursor: pointer">
            <img @click="getCode" :src="code" style="width: 80px; height: 30px; vertical-align: middle; margin-left: 25px" />
          </span>
        </div>
        <!-- <div style="margin: 10px 0px; display: none" class="protocol"><input name="protocol" type="checkbox" style="vertical-align: middle" /> <span class="protocol-btn" style="cursor: pointer">注册协议和隐私政策</span></div> -->
        <div v-if="action === ACTION.signIn" style="margin: 10px 0px; display: block" class="password"><span class="password-btn" style="cursor: pointer"><a href="/login?action=password">{{$t("account.forgotPassword")}}</a></span></div>
        <!-- <div v-show="action === ACTION.signIn" style="margin: 10px 0px;" class="login">
          <span @click="signIn" class="login-btn" style="cursor: pointer">立即登录</span>
        </div> -->
        <button @click="submit" :disabled="loading" type="button" style="margin-top: 60px" class="btn btn-primary btn-lg btn-block">{{$t("account.submit")}}</button>
        <!-- <button @click="submit" class="ui-button ui-button--primary submit-btn">提交</button> -->
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed, onMounted, reactive, ref } from "vue"
import router from "@/router"
import { toLogin, register, getCheckCode, forgetPassWord } from "@/utils/api"
import i18n from "@/i18n"

const ACTION = {
  signIn: "signIn",
  signUp: "signUp",
  password: "password"
}

const action = computed(() => {
  if (router.currentRoute.query.action) {
    if(router.currentRoute.query.action === ACTION.signUp) {
      return ACTION.signUp
    }
    if(router.currentRoute.query.action === ACTION.password) {
      return ACTION.password
    }
  }
  return ACTION.signIn
})

const loading = ref(false)
const code = ref()

const form = reactive({
  account: "",
  password: "",
  secondPassword: "",
  code: "",
  key: "",
  name: "",
  phone: "",
  userType: "",
  address: "",
})

const verify = () => {
  if (!form.account) {
    layer.msg(i18n.t("account.email")+" "+i18n.t("account.required"))
    return
  }
  if (!form.password) {
    layer.msg(i18n.t("account.password")+" "+i18n.t("account.required"))
    return
  }
  if (!form.code) {
    layer.msg(i18n.t("account.captcha")+" "+i18n.t("account.required"))
    return
  }
  if ((action.value === ACTION.signUp||action.value === ACTION.password) && !form.secondPassword) {
    layer.msg(i18n.t("account.confirmPassword")+" "+i18n.t("account.required"))
    return
  }
  if (action.value === ACTION.signUp && !form.name) {
    layer.msg('name'+" "+i18n.t("account.required"))
    return
  }
  if (action.value === ACTION.signUp && !form.phone) {
    layer.msg('phone number'+" "+i18n.t("account.required"))
    return
  }
  if (action.value === ACTION.signUp && !form.userType) {
    layer.msg('are you a personal buyer or wholesaler?')
    return
  }
  if (action.value === ACTION.signUp && !form.address) {
    layer.msg('where are you from?')
    return
  }
  if ((action.value === ACTION.signUp||action.value === ACTION.password) && form.password != form.secondPassword) {
    layer.msg(i18n.t("account.confirmPassword"))
    return
  }
  return true
}

const signIn = () => {
  if (!verify()) return
  loading.value = true
  toLogin({ account: form.account.trim(), password: form.password.trim(), code: form.code, key: form.key })
    .then((res) => {
      if(res.code === "-1001") {layer.msg(i18n.t("account.captcha")+" "+i18n.t("account.expire"));return}
      if(res.code === "-1002") {layer.msg(i18n.t("account.captcha")+" "+i18n.t("account.error"));return}
      if(res.code === "1003") {layer.msg(i18n.t("account.again"));return}
      if (res.data.token) {
        localStorage.setItem("token", res.data.token)
        layer.msg(i18n.t("account.success"))
        window.location.href = "/"
      }
    })
    .finally(() => {
      loading.value = false
      getCode()
    })
}
const signUp = () => {
  if (!verify()) return
  loading.value = true
  register({
    account: form.account.trim(),
    password: form.password.trim(),
    secondPassword: form.secondPassword.trim(),
    username: form.name.trim(),
    email: form.account.trim(),
    phone: form.phone.trim(),
    userType: form.userType,
    address: form.address.trim(),
    code: form.code, key: form.key
  })
    .then((res) => {
      if(res.code === "-1001") {layer.msg(i18n.t("account.captcha")+" "+i18n.t("account.expire"));return}
      if(res.code === "-1002") {layer.msg(i18n.t("account.captcha")+" "+i18n.t("account.error"));return}
      if (res.data.token) {
        localStorage.setItem("token", res.data.token)
        layer.msg(i18n.t("account.success"))
        window.location.href = "/"
      } else {
        layer.msg(res.msg)
      }
    })
    .finally(() => {
      loading.value = false
      getCode()
    })
}
const password = () => {
  if (!verify()) return
  loading.value = true
  forgetPassWord({
    account: form.account.trim(),
    password: form.password.trim(),
    secondPassword: form.secondPassword.trim(),
    email: form.account.trim(),
    code: form.code, key: form.key
  })
    .then((res) => {
      if(res.code === "-1001") {layer.msg(i18n.t("account.captcha")+" "+i18n.t("account.expire"));return}
      if(res.code === "-1002") {layer.msg(i18n.t("account.captcha")+" "+i18n.t("account.error"));return}
      if (res.data) {
        layer.msg(i18n.t("account.success"))
        window.location.href = "/login?action=signIn"
      } else {
        layer.msg(res.msg)
      }
    })
    .finally(() => {
      loading.value = false
      getCode()
    })
}
const submit = () => {
  switch (action.value) {
    case ACTION.signUp:
      signUp()
      break
    case ACTION.signIn:
      signIn()
      break
    case ACTION.password:
      password()
      break
  }
}

const getCode = () => {
  getCheckCode().then((res) => {
    code.value = "data:image/png;base64," + res.data.code
    form.key = res.data.key
  })
}

onMounted(() => {
  getCode()
})
</script>

<style scoped>
.main-view {
  padding: 0px;
  margin: 0px;
  color: #666666;
  font-size: 12px;
  line-height: 150%;
}
.main-view h1,
.main-view h2,
.main-view h3,
.main-view h4,
.main-view h5,
.main-view h6 {
  font-size: 100%;
  padding: 0px;
  margin: 0px;
  font-size: 1em;
  font-style: normal;
  font-weight: normal;
}
.black-logo {
  display: inline-block;
  margin: 30px 0 0 30px;
}
.login-form {
  width: 460px;
  margin: 0 auto;
}
.login-form .form-head {
  padding: 20px 40px;
  text-align: center;
}
.login-form .form-head h2 {
  margin: 0;
  font-size: 24px;
  line-height: 33px;
}
.login-form .form-head p {
  margin: 12px 0 0;
  line-height: 20px;
  color: #7b7f81;
}
.login-form .form-head p a {
  color: #7b7f81;
}
.login-form .form-body {
  padding: 20px 40px;
  font-size: 14px;
  color: #222;
}
.login-form .form-body .err-msg {
  color: #fc5c5c;
  margin: 0;
  line-height: 20px;
  text-align: center;
  font-size: 16px;
}
.ui-input {
  position: relative;
  padding: 15px 0;
  border-bottom: 1px solid #dfe6e5;
}
.ui-input input {
  width: 100%;
  height: 30px;
  font-size: 14px;
  outline: none;
  border: none;
}
.login-form .ui-button {
  width: 100%;
  margin: 60px 0 40px;
}
.ui-button--primary {
  background-color: #e30951;
  color: #fff;
  border: none;
}
.ui-button {
  min-width: 64px;
  height: 40px;
  font-weight: 500;
  font-size: 14px;
  outline: none;
  vertical-align: middle;
  border-radius: 2px;
  padding: 0;
  cursor: pointer;
}
.ui-button--primary:hover {
  background-color: #1ebb7f;
}
.form-body .narrow-input input {
  width: 270px;
}
.form-body .narrow-input button.sms-button {
  background: transparent;
  border: none;
  padding: 0;
  cursor: pointer;
  display: inline-block;
  width: 100px;
  text-align: right;
  color: #e30951;
  font-size: 14px;
  cursor: pointer;
}
.dialog__wrapper {
  display: none;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 99;
  background-color: rgba(0, 0, 0, 0.3);
}
.dialog {
  position: absolute;
  top: 20%;
  left: 50%;
  margin-left: -25%;
  width: 50%;
  background-color: #fff;
  border: 1px solid #e1e1e1;
}
.dialog__header {
  text-align: center;
  padding: 20px;
}
.dialog__title {
  font-size: 16px;
}
.dialog__headerbtn {
  border: none;
  background-color: transparent;
  font-size: 16px;
  cursor: pointer;
  float: right;
}
</style>
